import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { sha256 } from 'js-sha256'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getClaimByNumber, getHashes } from '../services/claimsService'

export const Lookup: React.FC = () => {
    const navigate = useNavigate()
    const [claimNumber, setClaimNumber] = useState('')
    const [payerId, setPayerId] = useState('')
    const [payerEDI, setPayerEDI] = useState('')
    const [providerTaxIDNumber, setProviderTaxIDNumber] = useState('')
    const [providerGroupNPI, setProviderGroupNPI] = useState('')
    const [providerGroupEDI, setProviderGroupEDI] = useState('')
    const [physicianNPI, setPhysicianNPI] = useState('')
    const [medicareInsuranceId, setMedicareInsuranceId] = useState('')
    const [patientDateOfBirth, setPatientDateOfBirth] = useState('')
    const [dateOfAdmission, setDateOfAdmission] = useState('')
    const [lookupByClaimNumberDisabled, setLookupByClaimNumberDisabled] = useState(true)
    const [lookupByInformationDisabled, setLookupByInformationDisabled] = useState(true)
    const [claimNumberFromHash, setClaimNumberFromHash] = useState('')
    const [keyHashValue, setKeyHashValue] = useState('')

    useEffect(() => {
        if (claimNumber.trim().length > 0) {
            getClaimByNumber(claimNumber)
                .then((response) => {
                    if (response && response.data) {
                        setLookupByClaimNumberDisabled(!response.data)
                    } else {
                        setLookupByClaimNumberDisabled(true) // response.error ?
                    }
                })
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                .catch((err: Error) => {
                    setLookupByClaimNumberDisabled(true)
                })
        } else {
            setLookupByClaimNumberDisabled(true)
        }
    }, [claimNumber])

    useEffect(() => {
        const value =
            payerId +
            payerEDI +
            providerTaxIDNumber +
            providerGroupNPI +
            providerGroupEDI +
            physicianNPI +
            medicareInsuranceId +
            patientDateOfBirth +
            dateOfAdmission
        if (value.trim().length > 0) {
            setKeyHashValue(value)
            const hash = sha256(value)
            getHashes(hash)
                .then((response) => {
                    if (response.data) {
                        setClaimNumberFromHash(response.data.claimNumber)
                        setLookupByInformationDisabled(false)
                    } else {
                        setLookupByInformationDisabled(true)
                    }
                })
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                .catch((err: Error) => {
                    setLookupByInformationDisabled(true)
                })
        } else {
            setLookupByInformationDisabled(true)
        }
    }, [
        payerId,
        payerEDI,
        providerTaxIDNumber,
        providerGroupNPI,
        providerGroupEDI,
        physicianNPI,
        medicareInsuranceId,
        patientDateOfBirth,
        dateOfAdmission,
        lookupByClaimNumberDisabled,
    ])

    return (
        <Grid container direction="column" style={{ padding: '40px' }}>
            <Grid item>
                <Typography variant="h3">Lookup</Typography>
                <Typography style={{ marginTop: '10px' }}>
                    Use one of the forms below to lookup a claim in the Rhiza Health system.
                </Typography>
            </Grid>
            <Grid item>
                <Box
                    style={{
                        marginTop: '30px',
                        padding: '30px',
                        backgroundColor: '#F2F6F9',
                        borderRadius: '10px',
                    }}
                >
                    <Typography variant="h6">Lookup by Claim Number</Typography>
                    <TextField
                        size="small"
                        fullWidth
                        style={{ backgroundColor: 'white', marginTop: '30px' }}
                        value={claimNumber}
                        onChange={(event) => setClaimNumber(event.target.value)}
                    />
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '30px',
                            alignItems: 'center',
                        }}
                    >
                        <Box style={{ marginLeft: '5px' }}>
                            {claimNumber.length > 0 && lookupByClaimNumberDisabled && (
                                <Typography style={{ color: 'grey' }}>
                                    Claim {claimNumber} not found
                                </Typography>
                            )}
                            {!lookupByClaimNumberDisabled && (
                                <Typography style={{ color: 'green' }}>
                                    Claim {claimNumber} found{' '}
                                </Typography>
                            )}
                        </Box>
                        <Button
                            style={{ minWidth: '120px' }}
                            disabled={lookupByClaimNumberDisabled}
                            variant="contained"
                            disableElevation={true}
                            onClick={() => navigate(`/claims/${claimNumber}/summary`)}
                        >
                            View Claim
                        </Button>
                    </Box>
                </Box>

                <Box
                    style={{
                        marginTop: '30px',
                        padding: '30px',
                        backgroundColor: '#F2F6F9',
                        borderRadius: '10px',
                    }}
                >
                    <Typography variant="h6" style={{ marginBottom: '30px' }}>
                        Lookup by Claim Information
                    </Typography>
                    <Grid container spacing={4}>
                        <Grid item xs={6}>
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Payer ID Number"
                                value={payerId}
                                onChange={(event) => setPayerId(event.target.value)}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Payer EDI"
                                value={payerEDI}
                                onChange={(event) => setPayerEDI(event.target.value)}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Provider TAX ID Number"
                                value={providerTaxIDNumber}
                                onChange={(event) => setProviderTaxIDNumber(event.target.value)}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Provider Group NPI"
                                value={providerGroupNPI}
                                onChange={(event) => setProviderGroupNPI(event.target.value)}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Provider Group EDI"
                                value={providerGroupEDI}
                                onChange={(event) => setProviderGroupEDI(event.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Individual Physician NPI"
                                value={physicianNPI}
                                onChange={(event) => setPhysicianNPI(event.target.value)}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Medicare Insurance ID"
                                value={medicareInsuranceId}
                                onChange={(event) => setMedicareInsuranceId(event.target.value)}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Patient Date of Birth (YYYYMMDD)"
                                value={patientDateOfBirth}
                                onChange={(event) => setPatientDateOfBirth(event.target.value)}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                style={{ marginBottom: '30px', backgroundColor: 'white' }}
                                label="Date of Admission (YYYYMMDD)"
                                value={dateOfAdmission}
                                onChange={(event) => setDateOfAdmission(event.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '30px',
                            alignItems: 'center',
                        }}
                    >
                        <Box style={{ marginLeft: '5px' }}>
                            {keyHashValue.length > 0 && lookupByInformationDisabled && (
                                <Typography style={{ color: 'grey' }}>
                                    No matching claim found
                                </Typography>
                            )}
                            {!lookupByInformationDisabled && (
                                <Typography style={{ color: 'green' }}>
                                    Found matching claim
                                </Typography>
                            )}
                        </Box>
                        <Button
                            style={{ minWidth: '120px' }}
                            disabled={lookupByInformationDisabled}
                            variant="contained"
                            disableElevation={true}
                            onClick={() => navigate(`/claims/${claimNumberFromHash}/summary`)}
                        >
                            View Claim
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}
